import { DialogService } from 'aurelia-dialog';
import { autoinject, bindable } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { AsyncErrorHandler, DialogHandler } from 'lib/ui';
import { CreateEditHourItemArgs, CreateEditHourItemDialog } from './create-edit-hour-item-dialog';
import { HourProductionOrderDto, MooringProductionTaskType, MooringProductionTaskTypeOptions } from 'models/mooring';
import { MooringProductionOrderService } from 'services/mooring';
import { ConfirmDialog } from 'components/dialogs/confirm/confirm-dialog';
import { ToastService } from 'services';
import { PubSub } from 'lib/event/PubSub';
import { MooringProductionOrderEvents } from './events';

@autoinject
export class Hours {
  @bindable
  productionOrderId: number;

  @bindable
  onSave: (params: { canNavigateOnSave: boolean }) => void;

  @bindable
  protected hours: HourProductionOrderDto[] = [];

  protected isCreating = false;

  constructor(
    private i18n: I18N,
    private productionOrderService: MooringProductionOrderService,
    private confirm: ConfirmDialog,
    private toaster: ToastService,
    private pubsub: PubSub,
    private dialog: DialogHandler
  ) {}

  protected attached() {
    if (!this.productionOrderId || this.productionOrderId <= 0) {
      throw new Error('productionOrderId is required');
    }
  }

  protected getTaskType(type: MooringProductionTaskType) {
    return this.i18n.tr(MooringProductionTaskTypeOptions.find((x) => x.id == type)?.label ?? 'general.unknown');
  }

  @AsyncErrorHandler
  protected handleSave() {
    if (this.onSave) {
      this.onSave({ canNavigateOnSave: true });
    }
  }

  protected async onEditHour(id: number) {
    const { wasCancelled } = await this.dialog.open(CreateEditHourItemDialog, {
      productionOrderId: this.productionOrderId,
      hourItemId: id,
    });

    if (!wasCancelled) {
      this.pubsub.publish('entity:updated', { name: MooringProductionOrderEvents.HOURS_ENTITY });
    }
  }

  @AsyncErrorHandler
  protected async onDelete(id: number) {
    const confirmed = await this.confirm.confirmDelete();

    if (confirmed) {
      await this.productionOrderService.deleteHour(this.productionOrderId, id);
      this.toaster.showDeleted();
      this.pubsub.publish('entity:deleted', { name: MooringProductionOrderEvents.HOURS_ENTITY });
    }
  }

  protected headers = [
    { title: this.i18n.tr('general.date') },
    { title: this.i18n.tr('general.task') },
    { title: this.i18n.tr('general.hour_plural') },
    { title: this.i18n.tr('general.user') },
    { title: this.i18n.tr('general.comment') },
    { title: this.i18n.tr('general.registeredBy') },
    { title: this.i18n.tr('general.created') },
    { title: this.i18n.tr('general.actions') },
  ];
}
